import HelpIcon from '@mui/icons-material/Help';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { driversContainer, helpIcon, overViewLeftText } from '../../styles';
import TripleToggleSwitch from '../atoms/triple-toggle-switch';

function DriverSelection({ label, description, value, onChange, disabled }) {
  const { t } = useTranslation();
  return (
    <div style={driversContainer}>
      <div style={overViewLeftText}>
        {t(label)}
        <Tooltip
          title={t(description)}
          placement="top-start"
          componentsProps={{
            tooltip: { sx: { fontSize: '14px' } },
          }}
        >
          <HelpIcon sx={helpIcon} />
        </Tooltip>
      </div>
      <div>
        <TripleToggleSwitch
          value={value}
          handleToggleChange={onChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default DriverSelection;
